import React from 'react';
import ApproveWaitlistModal from './modals/approveWaitlistModal';
import RemoveWaitlistModal from './modals/removeWaitlistModal';
import ViewsTable from '../../../components/tables/ViewsTable';
import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import InputField from '../../../components/inputs/inputField';
import { UncontrolledTooltip } from 'reactstrap';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';

class EventGroupWaitlist extends React.Component {
	constructor(props) {
		super(props);
		const columns = {
			firstName: 'First Name',
			lastName: 'Last Name',
			email: 'Email'
		};
		const columnTypes = {
			firstName: 'string',
			lastName: 'string',
			email: 'string'
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});
		this.state = {
			columns: columns,
			columnTypes: columnTypes,
			normalizedColumns: normalizedColumns,
			toggledColumns: toggledColumns,
			selectedColumnSort: null,
			sortDesc: false,
			searchTerm: ''
		};
	}

	/* Search */
	searchEntries = (searchText) => {
		this.setState({
			searching: searchText !== '' ? true : false,
			searchText: searchText || ''
		});
	};

	/* Download */
	s2ab = (s) => {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	};

	downloadReport = async () => {
		const { columns, columnTypes } = this.state;
		const waitlist = this.props.editedGroup.waitlist || [];
		const dataRows = [];
		waitlist.forEach((entry) => {
			const dataRow = {};
			Object.keys(columns).forEach((hc) => {
				if (entry[hc] != null) {
					if (columnTypes[hc] === 'boolean' || columnTypes[hc] === 'bool') {
						dataRow[hc] = entry[hc] ? 'Yes' : 'No';
					} else {
						dataRow[hc] = entry[hc];
					}
				}
			});
			dataRows.push(dataRow);
		});
		const cleanData = [];
		const headers = Object.keys(columns).map((header, hIndex) => {
			dataRows.forEach((data, dIndex) => {
				if (!cleanData[dIndex]) cleanData[dIndex] = [];
				cleanData[dIndex][hIndex] = data[header] || '';
			});
			return columns[header];
		});
		const data = { headerRow: headers, dataRows: cleanData };
		const reportDetails = {
			Title: this.props.editedGroup.name + ' Waitlist Report',
			Subject: 'Group Waitlist Report'
		};
		this.downloadRegular(reportDetails, data);
	};

	downloadRegular = (report, data) => {
		var wb = XLSX.utils.book_new();
		wb.Props = {
			Title: report.Title,
			Subject: report.Subject,
			Author: 'Simple Events',
			CreatedDate: new Date()
		};
		wb.SheetNames.push('Data');
		var ws_data2 = [data.headerRow, ...data.dataRows];
		var ws2 = XLSX.utils.aoa_to_sheet(ws_data2);
		wb.Sheets['Data'] = ws2;
		var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
		saveAs(
			new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
			`${report.Title}_${moment().format('LLL')}.xlsx`
		);
	};

	sortData = (column, sortAsc, sortDesc) => {
		const { normalizedColumns } = this.state;
		const updatedColumns = normalizedColumns.map((col) => {
			if (col.key === column.key) {
				col.sortAsc = sortAsc;
				col.sortDesc = sortDesc;
			} else {
				col.sortAsc = false;
				col.sortDesc = false;
			}
			return col;
		});
		this.setState({ normalizedColumns: updatedColumns, selectedColumnSort: column, sortDesc: sortDesc ? true : false });
	};

	render() {
		const { searchTerm, normalizedColumns, toggledColumns, selectedColumnSort, sortDesc, columns } = this.state;
		const { editedGroup, checkedWaitlist } = this.props;
		let waitlist = editedGroup.waitlist || [];
		let data = waitlist;

		if (searchTerm.length > 0) {
			const searchTerms = searchTerm.toLowerCase().split(' ');
			searchTerms.forEach((term) => {
				if (term !== '') {
					data = data.filter((entry) => {
						let found = false;
						Object.keys(columns).forEach((key) => {
							if (term !== '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
								found = true;
							}
						});
						return found;
					});
				}
			});
		}

		if (selectedColumnSort) {
			data = data.sort((a, b) => {
				const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
				if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
					switch (columnType) {
						case 'string':
							return a[selectedColumnSort.key].toLowerCase().trim().localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
						case 'number':
							return a[selectedColumnSort.key] - b[selectedColumnSort.key];
						case 'date':
						case 'time':
							return new Date(a[selectedColumnSort.key]).getTime() - new Date(b[selectedColumnSort.key]).getTime();
						case 'boolean':
							return (a[selectedColumnSort.key] ? 'yes' : 'no').localeCompare(b[selectedColumnSort.key] ? 'yes' : 'no');
						default:
							return a[selectedColumnSort.key].toLowerCase().trim().localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
					}
				} else if (a[selectedColumnSort.key]) {
					return 1;
				}
				return -1;
			});
			data = sortDesc ? data.reverse() : data;
		}

		const batchActions = [
			{
				type: 'button',
				label: 'Approve',
				onClick: this.props.toggleApproveWaitlist,
				iconClass: 'las la-check',
				class: 'prim'
			},
			{
				type: 'button',
				label: 'Remove',
				onClick: this.props.toggleDeleteWaitlist,
				iconClass: 'las la-trash-alt',
				class: 'danger'
			}
		];

		return (
			<div className="sectionBody3 posRel mb-0 p-0">
				<div className="actionButtonContainer headerHeight flex-ac">
					<ActionButtonContainer mainActions={[]} />
					<InputField
						classes="m-0 viewSearch"
						placeholder="Search"
						clickIcon={true}
						required={true}
						value={searchTerm}
						onChange={(e) => {
							clearTimeout(this.searchTimeout);
							this.setState({ searchTerm: e.target.value }, () => {
								this.searchTimeout = setTimeout(() => this.searchEntries(this.state.searchTerm), 1000);
							});
						}}
						prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
						inputIcon={
							searchTerm !== '' && (
								<i
									onMouseDown={() => this.setState({ searchTerm: '', searching: false }, () => this.searchEntries(''))}
									className="las la-times-circle"
									style={{ visibility: searchTerm === '' ? 'hidden' : 'visible' }}
								/>
							)
						}
					/>
					<div className="sectionOptionsContainer">
						<div id="downloadWaitlistTable" className="c-pointer fs-20" onClick={() => this.downloadReport()}>
							<i className="las la-download" />
							<UncontrolledTooltip target="downloadWaitlistTable" placement="left">
								Download Waitlist Data
							</UncontrolledTooltip>
						</div>
					</div>
				</div>
				<ViewsTable
					title="Waitlist"
					style={{ margin: 0 }}
					columns={normalizedColumns}
					toggledColumns={toggledColumns}
					data={data}
					mainColumnActive={false}
					checked={checkedWaitlist}
					checkRow={(entryId) => {
						const checked = { ...checkedWaitlist };
						checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
						this.props.updateChecked(checked);
					}}
					checkAllRows={(entryIds) => {
						let checked = { ...checkedWaitlist };
						entryIds.length > 0
							? entryIds.forEach((id) => { checked[id] = true; })
							: (checked = {});
						this.props.updateChecked(checked);
					}}
					sortData={this.sortData}
				/>
				<ActionButtonContainer
					mainActions={[]}
					batchActions={batchActions}
					checkedEntryCount={Object.keys(checkedWaitlist).length}
					entriesLength={waitlist.length}
					uncheckEntries={() => this.props.updateChecked({})}
				/>
				{this.props.approveWaitlistModalOpen && (
					<ApproveWaitlistModal
						isOpen={this.props.approveWaitlistModalOpen}
						toggle={this.props.toggleApproveWaitlist}
						group={editedGroup}
						existingAttendees={editedGroup.attendees}
						existingWaitlist={editedGroup.waitlist || []}
						checkedWaitlist={checkedWaitlist}
						orgId={this.props.orgId}
						eventId={this.props.event._id}
						approveWaitlistAttendees={this.props.approveWaitlistAttendees}
					/>
				)}
				{this.props.deleteWaitlistModalOpen && (
					<RemoveWaitlistModal
						isOpen={this.props.deleteWaitlistModalOpen}
						toggle={this.props.toggleDeleteWaitlist}
						group={editedGroup}
						existingWaitlist={editedGroup.waitlist || []}
						checkedWaitlist={checkedWaitlist}
						orgId={this.props.orgId}
						eventId={this.props.event._id}
						removeWaitlistAttendees={this.props.removeWaitlistAttendees}
					/>
				)}
			</div>
		);
	}
}

export default EventGroupWaitlist;
